var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreyRemove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4184 15.0053C16.8094 15.3964 16.8094 16.0283 16.4184 16.4194C16.2234 16.6144 15.9675 16.7124 15.7113 16.7124C15.4553 16.7124 15.1993 16.6144 15.0043 16.4194L11.9994 13.4143L8.99443 16.4194C8.79942 16.6144 8.54344 16.7124 8.28746 16.7124C8.0313 16.7124 7.77531 16.6144 7.58031 16.4194C7.18938 16.0283 7.18938 15.3964 7.58031 15.0053L10.5854 12.0004L7.58031 8.99541C7.18938 8.60429 7.18938 7.9724 7.58031 7.58128C7.97142 7.19035 8.60332 7.19035 8.99443 7.58128L11.9994 10.5864L15.0043 7.58128C15.3954 7.19035 16.0273 7.19035 16.4184 7.58128C16.8094 7.9724 16.8094 8.60429 16.4184 8.99541L13.4133 12.0004L16.4184 15.0053Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreyRemove);
export default __webpack_public_path__ + "static/media/icon-grey-remove.c3017f9304d87d3829e05ce125d463b6.svg";
export { ForwardRef as ReactComponent };